<div *ngIf="dataSource">
  <ng-container *ngFor="let key of Object.keys(dataSource)">
    <div>
      <app-input-summary-subtable
        [subtable]="dataSource[key]"
        [level]="1"
        [sectionTitle]="key"
      >
      </app-input-summary-subtable>
    </div>
  </ng-container>
</div>

